<div>

    <div class="page_title">
        <div class="row marges">
            <div class="col y_items_center">
                <h1 class="title">{{ 'offer.own.distributor.plural.value' | translate }}</h1>
            </div>
        </div>
    </div>

    <div class="content_table">
        <table mat-table matSort [dataSource]="items" class="mat-elevation-z8">

            <!-- Filtres -->

            <ng-container>

                <!--Actions-->

                <ng-container [matColumnDef]="getFilterColumnDef('actions')">
                    <th mat-header-cell *matHeaderCellDef>
                        <button (click)="resetFilters()" mat-icon-button>
                            <mat-icon>loop</mat-icon>
                        </button>
                    </th>
                </ng-container>

                <!-- Nom du distributeur -->

                <ng-container [matColumnDef]="getFilterColumnDef('distributor.name')">
                    <th mat-header-cell *matHeaderCellDef>
                        <app-core-text-filter #filter [builder]="filterBuilder" [label]="'distributor.name.value' | translate" [key]="'distributor.name'" [operator]="'lk'"></app-core-text-filter>
                    </th>
                </ng-container>

                <!-- Rôle utilisateur -->

                <ng-container [matColumnDef]="getFilterColumnDef('distributor.admin.roles')">
                    <th mat-header-cell *matHeaderCellDef>
                        <app-core-select-array-multiple-filter #filter [builder]="filterBuilder" [label]="'distributor.type.value' | translate" [key]="'distributor.admin.roles'" [operator]="'andlkin'" [itemValueProperty]="'identifier'" [itemLabelProperty]="'label'" [items]="filterRoles"></app-core-select-array-multiple-filter>
                    </th>
                </ng-container>

                <!-- Nom de l'administrateur du compte distributeur -->

                <ng-container [matColumnDef]="getFilterColumnDef('distributor.admin.lastName')">
                    <th mat-header-cell *matHeaderCellDef>
                        <app-core-text-filter #filter [builder]="filterBuilder" [label]="'distributor.admin.lastName.value' | translate" [key]="'distributor.admin.lastName'" [operator]="'lk'"></app-core-text-filter>
                    </th>
                </ng-container>

                <!-- Prénom de l'administrateur du compte distributeur -->

                <ng-container [matColumnDef]="getFilterColumnDef('distributor.admin.firstName')">
                    <th mat-header-cell *matHeaderCellDef>
                        <app-core-text-filter #filter [builder]="filterBuilder" [label]="'distributor.admin.firstName.value' | translate" [key]="'distributor.admin.firstName'" [operator]="'lk'"></app-core-text-filter>
                    </th>
                </ng-container>

                <!-- Nom du distributeur -->

                <ng-container [matColumnDef]="getFilterColumnDef('distributor.website')">
                    <th mat-header-cell *matHeaderCellDef>
                        <app-core-text-filter #filter [builder]="filterBuilder" [label]="'distributor.website.value' | translate" [key]="'distributor.websites.website'" [operator]="'lk'"></app-core-text-filter>
                    </th>
                </ng-container>

                <!-- Nom du distributeur -->

                <ng-container [matColumnDef]="getFilterColumnDef('distributor.addresses.city')">
                    <th mat-header-cell *matHeaderCellDef>
                        <app-core-text-filter #filter [builder]="filterBuilder" [label]="'distributor.address.city.value' | translate" [key]="'distributor.addresses.city'" [operator]="'lk'"></app-core-text-filter>
                    </th>
                </ng-container>

                <!-- Type de commission -->

                <ng-container [matColumnDef]="getFilterColumnDef('distributor.commission.type')">
                    <th mat-header-cell *matHeaderCellDef>
                        <app-core-select-filter #filter [builder]="filterBuilder" [label]="'distributor.commission.type.value' | translate" [key]="'distributor.commission.enable'" [operator]="'eq'" [itemValueProperty]="'identifier'" [itemLabelProperty]="'label'" [items]="filterCommissionTypes"></app-core-select-filter>
                    </th>
                </ng-container>

                <!-- Accès aux offres -->

                <ng-container [matColumnDef]="getFilterColumnDef('hasAccessOffers')">
                    <th mat-header-cell *matHeaderCellDef>
                        <app-core-select-boolean-filter #filter [builder]="filterBuilder" [label]="'distributor.hasAccessOffers.value' | translate" [key]="'hasAccessOffers'" [truthyLabel]="'yes.value' | translate" [falsyLabel]="'no.value' | translate"></app-core-select-boolean-filter>
                    </th>
                </ng-container>

                <!-- Nombre d'offres acceptées -->

                <ng-container [matColumnDef]="getFilterColumnDef('totalAcceptedMarketplaceOffers')">
                    <th mat-header-cell *matHeaderCellDef></th>
                </ng-container>

                <!-- Nombre d'offres refusées -->

                <ng-container [matColumnDef]="getFilterColumnDef('totalRefusedMarketplaceOffers')">
                    <th mat-header-cell *matHeaderCellDef></th>
                </ng-container>

            </ng-container>

            <!-- Ligne de données -->

            <ng-container>

                <!-- Actions -->

                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef>{{'actions.label.value' | translate}}</th>
                    <mat-cell *matCellDef="let element; let i = index">
                        @if(hasAccessEdit()) {
                            <button mat-button (click)="editItem(getModel(element))">
                                <mat-icon>edit</mat-icon>
                            </button>
                        }
                        @if(hasAccessDelete()) {
                            <button mat-button (click)="openDeleteItemDialog(getModel(element))">
                                <mat-icon>delete</mat-icon>
                            </button>
                        }
                    </mat-cell>
                </ng-container>

                <!-- Nom du distributeur -->

                <ng-container matColumnDef="distributor.name">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'distributor.name.value' | translate}}</th>
                    <td mat-cell *matCellDef="let element">{{getModel(element).distributor.name}}</td>
                </ng-container>

                <!-- Rôle utilisateur -->

                <ng-container matColumnDef="distributor.admin.roles">
                    <th mat-header-cell *matHeaderCellDef>{{'distributor.type.value' | translate}}</th>
                    <td mat-cell *matCellDef="let element">{{getModel(element).distributor.admin ? getRoleLabel(getModel(element).distributor.admin.roles) : null}}</td>
                </ng-container>

                <!-- Nom de l'administrateur du compte distributeur -->

                <ng-container matColumnDef="distributor.admin.lastName">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'distributor.admin.lastName.value' | translate}}</th>
                    <td mat-cell *matCellDef="let element">{{getModel(element).distributor.admin.lastName}}</td>
                </ng-container>

                <!-- Prénom de l'administrateur du compte distributeur -->

                <ng-container matColumnDef="distributor.admin.firstName">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'distributor.admin.firstName.value' | translate}}</th>
                    <td mat-cell *matCellDef="let element">{{getModel(element).distributor.admin.firstName}}</td>
                </ng-container>

                <!-- Site Web du distributeur -->

                <ng-container matColumnDef="distributor.website">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'distributor.website.value' | translate}}</th>
                    <td mat-cell *matCellDef="let element">{{getModel(element).distributor.mainWebsite}}</td>
                </ng-container>

                <!-- Ville du distributeur -->

                <ng-container matColumnDef="distributor.addresses.city">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'distributor.address.city.value' | translate}}</th>
                    <td mat-cell *matCellDef="let element">{{ getAddressFields(getModel(element)).city }}</td>
                </ng-container>

                <!-- Type de commission -->

                <ng-container matColumnDef="distributor.commission.type">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'distributor.commission.type.value' | translate}}</th>
                    <td mat-cell *matCellDef="let element">{{ getCommissionTypeLabel(getModel(element)) }}</td>
                </ng-container>

                <!-- Accès aux offres -->

                <ng-container matColumnDef="hasAccessOffers">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'distributor.hasAccessOffers.value' | translate}}</th>
                    <td mat-cell *matCellDef="let element">{{ ((getModel(element).hasAccessOffers ? 'yes' : 'no') + '.value') | translate }}</td>
                </ng-container>

                <!-- Nombre d'offres acceptées -->

                <ng-container matColumnDef="totalAcceptedMarketplaceOffers">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'distributor.marketplace.accepted.value' | translate}}</th>
                    <td mat-cell *matCellDef="let element">{{getModel(element).totalAcceptedMarketplaceOffers }}</td>
                </ng-container>

                <!-- Nombre d'offres refusées -->

                <ng-container matColumnDef="totalRefusedMarketplaceOffers">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'distributor.marketplace.refused.value' | translate}}</th>
                    <td mat-cell *matCellDef="let element">{{getModel(element).totalRefusedMarketplaceOffers }}</td>
                </ng-container>

            </ng-container>

            <!-- Entêtes de colonne -->

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

            <!-- Filtres -->

            <tr mat-header-row *matHeaderRowDef="displayedFilterColumns"></tr>

            <!-- Ligne de données -->

            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        </table>
    </div>

    <!--Pagination-->

    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" [length]="totalItems"></mat-paginator>
</div>

